import React, { useEffect, useState } from 'react'
import { supabase } from '../../../lib/api'
import { flipDate } from '../../../lib/dates'
import { Tooltip } from '@mui/material'

export function TableObjetosRetirados({ language, userId }) {
    const [objetos, setObjetos] = useState([])

    useEffect(() => {
        fetchObjects()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchObjects = async () => {
        let { data, error } = await supabase
            .from('intercanviat_objectes')
            .select(
                'codi_objecte, data_recepcio, tipologia_objecte, descripcio, massa, estat_objecte, puntuacio_objecte'
            )
            .eq('nou_propietari', userId)
            .order('data_recepcio', { ascending: false })

        if (error) {
            console.log(error)
            return false
        }

        setObjetos(data)
    }
    const handleDescripcion = (descripcion) => {
        if (descripcion.length > 50) {
            return (
                <span>
                    {descripcion.substring(0, 50)}
                    <Tooltip title={descripcion}>
                        <span className="text-blue-800 font-bold underline ml-1">...</span>
                    </Tooltip>
                </span>
            )
        }
        return descripcion
    }

    return (
        <>
            {objetos.length === 0 ? (
                <div className="alert alert-warning" role="alert">
                    {language === 'castellano' ? 'No tienes objetos depositados.' : 'No tens objectes dipositats.'}
                </div>
            ) : (
                <div className="overflow-x-auto w-full">
                    <table class="table">
                        <thead>
                            <tr>
                                {language === 'castellano' ? (
                                    <>
                                        <th scope="col">Código</th>
                                        <th scope="col">Fecha recepción</th>
                                        <th scope="col">Tipología</th>
                                        <th scope="col">Descripción</th>
                                        <th scope="col">Masa</th>
                                        <th scope="col">Estado</th>
                                        <th scope="col">Puntuación</th>
                                    </>
                                ) : (
                                    <>
                                        <th scope="col">Codi</th>
                                        <th scope="col">Data recepció</th>
                                        <th scope="col">Tipologia</th>
                                        <th scope="col">Descripció</th>
                                        <th scope="col">Massa</th>
                                        <th scope="col">Estat</th>
                                        <th scope="col">Puntuació</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {objetos?.map(
                                ({
                                    codi_objecte,
                                    data_recepcio,
                                    tipologia_objecte,
                                    descripcio,
                                    massa,
                                    estat_objecte,
                                    puntuacio_objecte,
                                }) => (
                                    <tr>
                                        <th scope="row">{codi_objecte}</th>
                                        <td>{flipDate(data_recepcio)}</td>
                                        <td>{tipologia_objecte}</td>
                                        <td>{handleDescripcion(descripcio)}</td>
                                        <td>{massa} kg</td>
                                        <td>{estat_objecte}</td>
                                        <td>{puntuacio_objecte}</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    )
}
